import { TweenMax, TimelineMax } from 'gsap';
import css from './index.module.scss';
import AniFGsapA1 from './aniFGsapA1';
import AniFGsapB1 from './aniFGsapB1';
import { useGlobal } from '@/utils/useGlobal';

export default function AnimationF({}: any) {
    const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;
    const { useEffect } = useGlobal();

    useEffect(() => {
        const controller = new ScrollMagic.Controller();
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.animationF .anif-img-box',
            offset: 0, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: layoutH / 5, //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const tweenA1 = TweenMax.to('.animationF .aniFGsapB1 .img-t-2', 1.5, {
            opacity: 1,
            y: -110,
        });
        const tweenA2 = TweenMax.to('.animationF .aniFGsapB1 .img-t-1-in1', 0.5, {
            opacity: 0,
        });
        const tweenA3 = TweenMax.to('.animationF .aniFGsapB1 .img-t-1-in2', 0.5, {
            opacity: 1,
        });

        const timelineA1 = new TimelineMax();
        timelineA1.add(tweenA1).add(tweenA2, 1.5).add(tweenA3, 1.5);

        sceneA1.setTween(timelineA1);
        controller.addScene(sceneA1);
    }, []);

    return (
        <div className={`${css.animationF} animationF`}>
            <AniFGsapA1 />
            <div id="animationF-trigger-1"></div>
            <AniFGsapB1 />
        </div>
    );
}
